// extracted by mini-css-extract-plugin
export default {"logo--small":"Logo_logo--small__+keLY","logo--medium":"Logo_logo--medium__bkn3x","logo--large":"Logo_logo--large__-yw9n"};